// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.openseadragon-viewer {
    background-color: #ffffff;
    border: 1px solid #e1e5e9;
    border-radius: 12px;
    padding: 8px;
    margin: 5px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.viewer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding: 4px 0;
    border-bottom: 1px solid #f1f3f4;
}

.viewer-header h3 {
    margin: 0;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
}

.viewer-controls {
    display: flex;
    gap: 8px;
}

.viewer-controls button {
    padding: 8px 12px;
    border: 1px solid #dadce0;
    border-radius: 6px;
    background-color: #ffffff;
    color: #5f6368;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
}

.viewer-controls button:hover {
    border-color: #4285f4;
    color: #4285f4;
    box-shadow: 0 1px 3px rgba(66, 133, 244, 0.2);
}

.viewer-controls button:active {
    background-color: #f8f9fa;
    transform: translateY(1px);
}

.viewer-container {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    flex: 1 1;
    min-height: 280px;
    min-width: 0;
}

.openseadragon-container {
    background-color: #000000;
    border: 1px solid #e9ecef;
    height: 100%;
    width: 100%;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #4285f4;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-overlay p {
    margin: 0;
    color: #5f6368;
    font-size: 14px;
    font-weight: 500;
}

/* OpenSeadragon specific styling */
.openseadragon-container .openseadragon-canvas {
    border-radius: 8px;
}

/* Custom OpenSeadragon button styling */
.openseadragon-container .openseadragon-button {
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #dadce0;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.openseadragon-container .openseadragon-button:hover {
    background-color: #f8f9fa;
    border-color: #4285f4;
}

.openseadragon-container .openseadragon-button:active {
    background-color: #e8f0fe;
    transform: translateY(1px);
}

/* Mouse coordinates display */
.mouse-coords-display {
    position: absolute;
    bottom: 10px;
    left: 10px;
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #dadce0;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    color: #5f6368;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    z-index: 100;
}

.coord-item {
    margin: 2px 0;
}

.coord-item span {
    font-family: 'Courier New', monospace;
}

/* Slice controls */
.slice-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 10px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #dee2e6;
}

.slice-controls label {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    margin: 0;
}

.slice-slider {
    width: 100px;
    height: 20px;
    background: #ddd;
    outline: none;
    border-radius: 10px;
    cursor: pointer;
}

.slice-slider::-webkit-slider-thumb {
    appearance: none;
    width: 16px;
    height: 16px;
    background: #007bff;
    border-radius: 50%;
    cursor: pointer;
}

.slice-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: #007bff;
    border-radius: 50%;
    cursor: pointer;
    border: none;
}

.slice-info {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    min-width: 40px;
    text-align: center;
}

/* ROI Overlay Styles */
.roi-overlay {
    background-color: transparent;
    border: 2px solid;
    border-radius: 2px;
    pointer-events: none;
    z-index: 10;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

.roi-overlay--selected {
    box-shadow: 0 0 6px rgba(37, 99, 235, 0.55);
}`, "",{"version":3,"sources":["webpack://./src/components/OpenSeadragonViewer/OpenSeadragonViewer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4DAA4D;IAC5D,wCAAwC;IACxC,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,SAAO;IACP,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".openseadragon-viewer {\n    background-color: #ffffff;\n    border: 1px solid #e1e5e9;\n    border-radius: 12px;\n    padding: 8px;\n    margin: 5px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.viewer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding: 4px 0;\n    border-bottom: 1px solid #f1f3f4;\n}\n\n.viewer-header h3 {\n    margin: 0;\n    color: #1a1a1a;\n    font-size: 18px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.viewer-controls {\n    display: flex;\n    gap: 8px;\n}\n\n.viewer-controls button {\n    padding: 8px 12px;\n    border: 1px solid #dadce0;\n    border-radius: 6px;\n    background-color: #ffffff;\n    color: #5f6368;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 14px;\n}\n\n.viewer-controls button:hover {\n    border-color: #4285f4;\n    color: #4285f4;\n    box-shadow: 0 1px 3px rgba(66, 133, 244, 0.2);\n}\n\n.viewer-controls button:active {\n    background-color: #f8f9fa;\n    transform: translateY(1px);\n}\n\n.viewer-container {\n    position: relative;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    flex: 1;\n    min-height: 280px;\n    min-width: 0;\n}\n\n.openseadragon-container {\n    background-color: #000000;\n    border: 1px solid #e9ecef;\n    height: 100%;\n    width: 100%;\n}\n\n.loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.9);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #4285f4;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.loading-overlay p {\n    margin: 0;\n    color: #5f6368;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n/* OpenSeadragon specific styling */\n.openseadragon-container .openseadragon-canvas {\n    border-radius: 8px;\n}\n\n/* Custom OpenSeadragon button styling */\n.openseadragon-container .openseadragon-button {\n    background-color: rgba(255, 255, 255, 0.9);\n    border: 1px solid #dadce0;\n    border-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.openseadragon-container .openseadragon-button:hover {\n    background-color: #f8f9fa;\n    border-color: #4285f4;\n}\n\n.openseadragon-container .openseadragon-button:active {\n    background-color: #e8f0fe;\n    transform: translateY(1px);\n}\n\n/* Mouse coordinates display */\n.mouse-coords-display {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    background-color: rgba(255, 255, 255, 0.9);\n    border: 1px solid #dadce0;\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #5f6368;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n}\n\n.coord-item {\n    margin: 2px 0;\n}\n\n.coord-item span {\n    font-family: 'Courier New', monospace;\n}\n\n/* Slice controls */\n.slice-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: 10px;\n    padding: 4px 8px;\n    background-color: #f8f9fa;\n    border-radius: 4px;\n    border: 1px solid #dee2e6;\n}\n\n.slice-controls label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #495057;\n    margin: 0;\n}\n\n.slice-slider {\n    width: 100px;\n    height: 20px;\n    background: #ddd;\n    outline: none;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.slice-slider::-webkit-slider-thumb {\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #007bff;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.slice-slider::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: #007bff;\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n}\n\n.slice-info {\n    font-size: 12px;\n    font-weight: 500;\n    color: #495057;\n    min-width: 40px;\n    text-align: center;\n}\n\n/* ROI Overlay Styles */\n.roi-overlay {\n    background-color: transparent;\n    border: 2px solid;\n    border-radius: 2px;\n    pointer-events: none;\n    z-index: 10;\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);\n}\n\n.roi-overlay--selected {\n    box-shadow: 0 0 6px rgba(37, 99, 235, 0.55);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
